import { render, staticRenderFns } from "./AddMessageSideSheet.vue?vue&type=template&id=30c5d0e2&scoped=true"
import script from "./AddMessageSideSheet.vue?vue&type=script&lang=js"
export * from "./AddMessageSideSheet.vue?vue&type=script&lang=js"
import style0 from "./AddMessageSideSheet.vue?vue&type=style&index=0&id=30c5d0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c5d0e2",
  null
  
)

export default component.exports